import { useAppEvents } from '@/events';

import { BookingPaymentEvents } from '../events';

export const useBookingPaymentEvents = () =>
  useAppEvents<BookingPaymentEvents>();
